<template>
  <div>
    <div class="background"></div>
    <div class="main">
      <div class="kch">
        <img style="width: 200px" :src="require('../assets/Eitan Image.jpeg')" />
      </div>

      <div class="weather">
        <p class="date-time">{{ time }}</p>
        <weather
          api-key="78da2d7e5961a2030a538fc55b4c5ec0"
          latitude="42.3601"
          longitude="-71.0589"
          language="en"
          :hide-header="true"
          units="us"
        ></weather>
      </div>

      <div v-if="initAnnouncement" class="announcement-modal">
        <p v-html="announcement.text"></p>
      </div>

      <div class="scroller" :style="{ width: `100%` }">
        <infinite-slide-bar
          duration="100s"
          :barStyle="{
            background: ' rgb(29, 61, 135)',
            padding: '20px 0',
            position: 'fixed',
            bottom: '0',
          }"
        >
          <div class="feed">
            <div v-for="item in items" :key="items.indexOf(item)">
              <li class="rss-title">{{ item.title }}</li>
            </div>
          </div>
        </infinite-slide-bar>
      </div>

      <div class="right">
        <div v-if="currentImg">
          <transition-group name="fade" tag="div">
            <div v-for="i in [currentIndex]" :key="i">
              <img
                id="image"
                class="show"
                v-if="currentImg.type.includes('image')"
                :src="currentImg.url"
              />

              <video
                @loadstart="stopTimer"
                @ended="startSlide"
                v-else-if="currentImg.type.includes('video')"
                id="image"
                class="show"
                autoplay
                muted
                :src="currentImg.url"
              ></video>
              <pdf v-else id="image" class="show" :src="currentImg.url"></pdf>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InfiniteSlideBar from "vue-infinite-slide-bar";

import VueWeatherWidget from "vue-weather-widget";
import "vue-weather-widget/dist/css/vue-weather-widget.css";
import { db } from "@/config/firebaseInit.js";
import pdf from "vue-pdf";

import moment from "moment";

export default {
  name: "Main",
  components: { InfiniteSlideBar, weather: VueWeatherWidget, pdf },
  data() {
    return {
      backgroundImages: [],
      announcement: null,
      currentIndex: 0,
      initAnnouncement: false,
      nextSlide: 0,
      bgImage: true,
      bgVideo: false,
      configs: {},
      time: moment().format("MMMM Do YYYY, h:mm a"),
      items: [],
      feed:
        "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.who.int%2Frss-feeds%2Fnews-english.xml",
    };
  },
  props: {},
  async created() {
    await this.fetchData();

    db.collection("kiosks").onSnapshot((snapshot) => {
      var init = false;
      var id = null;
      snapshot.docChanges().forEach((change) => {
        if (change.type === "modified") {
          let defaulted = change.doc.data().default;
          if (defaulted) {
            id = change.doc.id;
            init = true;
          }
        }
      });

      if (init) {
        this.$router.push("/home/" + id);
        window.location.reload();
      }
    });
    await db
      .collection("gallery")
      .where("kiosks", "array-contains", this.$route.params.id)
      .where("published", "==", true)
      .onSnapshot((query) => {
        if (!query.empty) {
          this.configs = query.docs[0].data();

          this.backgroundImages = this.configs.media_collection.map((i) => {
            return Object.assign({
              url: i.url,
              type: i.type ? i.type : "image",
            });
          });

          if (this.configs.autoplayDirection == "backward") {
            this.backgroundImages = this.backgroundImages.reverse();
          }

          this.createUrls();
          this.startSlide();
          this.startTime();
        } else {
          this.$router.push("/");
        }
      });

    await db
      .collection("announcements")
      .where("kiosks", "array-contains", this.$route.params.id)
      .where("published", "==", true)
      .onSnapshot((query) => {
        if (!query.empty) {
          this.announcement = query.docs[0].data();
          this.setAnnouncement();
        }
      });
  },

  methods: {
    stopTimer() {
      clearInterval(this.timer);
    },
    startSlide: function() {
      let speed = parseInt(this.configs.speed) * 1000;
      clearInterval(this.timer);
      this.timer = setInterval(this.next, speed);
    },
    async setAnnouncement() {
      if (this.announcement.interval) {
        let interval_time = this.announcement.interval * 1000;
        let idle_time = this.announcement.idle_time * 1000;

        let intervalTimeout = () => (this.initAnnouncement = true);
        let idleTimeout = () => (this.initAnnouncement = false);

        let alternate = !this.initAnnouncement ? intervalTimeout : idleTimeout;
        let time = this.initAnnouncement ? idle_time : interval_time;
        setTimeout(async () => {
          await alternate();
          this.setAnnouncement();
        }, time);
      }
    },
    startTime() {
      setInterval(() => {
        this.time = moment().format("MMMM Do YYYY, h:mm a");
      }, 1000);
    },
    createUrls() {
      this.backgroundImages.map((url) => {
        return `require(${url})`;
      });
    },

    next: function() {
      this.currentIndex += 1;
    },

    previous: function() {
      if (!this.currentIndex) {
        this.currentIndex = this.backgroundImages.length - 1;
        return;
      }

      this.currentIndex -= 1;
    },
    fetchData() {
      fetch(this.feed)
        .then((response) => {
          response = response.json();
          return response;
        })
        .then((response) => {
          this.items = response.items;
        });
    },
    changeHandler(event) {
      this.feed = event.target.value;
      this.fetchData();
    },
  },
  computed: {
    currentImg: function() {
      return this.backgroundImages[
        Math.abs(this.currentIndex) % this.backgroundImages.length
      ];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
